/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './emitEvent.defs.js'
export * as $defs from './emitEvent.defs.js'
